// index.js - WEB
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import App from './App';
import swDev from './swDev'
import registerServiceWorker from "../../components/src/registerServiceWorker";

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('root')
);
swDev();
// registerServiceWorker();
// set PORT=443 && 
